import SearchIcon from '@mui/icons-material/Search';
import {Box, Divider, Stack, Typography} from '@mui/material';
import { useTranslation } from 'react-i18next';

import SelectFileComponent from '@components/inputs/selectFile/SelectFile.component';
import TextFieldComponent from '@components/inputs/textField/TextField.component';
import { Sizes } from '@constants/sizes.constants';

import { CreateAuditInformation } from '@store/audits/audits-information/audits-information.model';
import React, {useEffect} from 'react';
import { useParams } from 'react-router-dom';
import {File} from '@icons/index';
import {DocumentInfo, DocumentKind, filesService} from '@store/files';
import {useSnackbar} from 'notistack';
// @ts-ignore
import FilesCard from '@components/cards/files/Files.card';

interface PreAuditProps {
  updateAuditInformation: (
    field: keyof CreateAuditInformation, value: any
  ) => void;
  auditInformation?: CreateAuditInformation;
  isAudit?: boolean;
  errors:any;
}
const PreAuditObservation = (props: PreAuditProps) => {
  const { isAudit = false, auditInformation, updateAuditInformation, errors } = props;
  const { t } = useTranslation();
  const { auditId } = useParams();
    const {enqueueSnackbar} = useSnackbar();
  useEffect(() => {
    if (auditId) {
      updateAuditInformation('observation', { auditId: Number(auditId) });
    }
  }, [auditId, updateAuditInformation]);


    const removeDocumentFromAddedDocuments = (document: DocumentInfo) => {
        const docs = auditInformation?.observation?.addedDocuments?.filter((doc) => doc.id !== document.id);
        updateAuditInformation('observation', {
            addedDocuments: docs
        });
    };

    const removeDocuments = (document: number) => {
        const docs = auditInformation?.observation?.deletedDocuments ?? [];
        docs.push(document);
        updateAuditInformation('observation', {
            deletedDocuments: docs
        });
    };
    const addDocument = (file: File) => {
        filesService.uploadFile(file, DocumentKind.ISSUE).pipe().subscribe({
            next: (document) => {
                const docs = auditInformation?.observation?.addedDocuments ?? [];
                docs.push(document);
                updateAuditInformation('observation', {
                    addedDocuments: docs
                });
            },
            error: (err) => enqueueSnackbar(err.text, err.options),
        });
    };

  return (
    <>
      <Stack py="24px" pr="10px">
        {isAudit ? <Stack direction="row" mt="3px" alignItems="center" spacing={0.5}>
          <SearchIcon sx={{ backgroundColor: '#6FD969', borderRadius: '2px', width: '25px', color: 'white' }} />
          <Typography fontSize={24} fontWeight="700">
            {t('audits.preAudit.types.observation')}
          </Typography>
        </Stack> : null}
        <Stack py="24px" pr="10px" spacing={1.5}>
         <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography fontSize="18px" fontWeight="700">
              {t('audits.preAudit.observations.pictures')}
            </Typography>
            <SelectFileComponent handleFileSelected={addDocument} />
          </Stack>
            <Box>
                {auditInformation?.observation?.addedDocuments?.length !== 0 && auditInformation?.observation?.addedDocuments?.map((photo) => {
                    return (
                        <FilesCard document={photo} disableOnClick handleDeleteDocument={() => removeDocumentFromAddedDocuments(photo)}/>
                    );
                })}

                {auditInformation?.observation?.photos?.length !== 0 && auditInformation?.observation?.photos?.map((photo) => (
                    !auditInformation?.observation?.deletedDocuments?.includes(photo.id) && (
                        photo.name && (
                            <FilesCard document={photo} disableOnClick handleDeleteDocument={() => removeDocuments(photo.id)}/>
                        )
                    )
                ))}
            </Box>
          <Divider variant="fullWidth" orientation="horizontal" />
          <TextFieldComponent
            multiline
            color="primary"
            labelWidth={Sizes.drawerInputLabelWidth}
            placeholder={t('audits.preAudit.observations.observations') + '*'}
            handleChange={(observation) => updateAuditInformation('observation', { observation: observation })}
            value={auditInformation?.observation?.observation ?? ''}
            rows={10}
            error={errors.observation}
            required={true}
          />
          <Divider variant="fullWidth" orientation="horizontal" />
        </Stack>
      </Stack>
    </>
  );
};

export default PreAuditObservation;
